"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemTypes = void 0;
var _hooks = require("../../../../../hooks");
var _Item = require("../../Item.labels");
var _ItemTypes = require("./ItemTypes.styles");
var _ItemType = require("./partials/ItemType");
var _jsxRuntime = require("react/jsx-runtime");
var ItemTypes = function ItemTypes(props) {
  var _Object$keys;
  var _props$isMobileSuppor = props.isMobileSupported,
    isMobileSupported = _props$isMobileSuppor === void 0 ? false : _props$isMobileSuppor,
    itemTypes = props.itemTypes,
    _props$view = props.view,
    view = _props$view === void 0 ? 'default' : _props$view;
  var styles = (0, _ItemTypes.useStyles)(props);
  var getLabel = (0, _hooks.useLabels)({
    labels: _Item.labels
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Item__types'],
    children: [itemTypes && ((_Object$keys = Object.keys(itemTypes)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(function (key) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ItemType.ItemType, {
        title: itemTypes[key],
        view: view
      }, key);
    })), isMobileSupported && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ItemType.ItemType, {
      title: getLabel('mobile_compatible'),
      view: view
    })]
  });
};
exports.ItemTypes = ItemTypes;